<template>
  <div>
    <GmapMap :style="`height: ${height}`" ref="mapRef" :options="{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false
    }" :center="center" :zoom="zoom" map-type-id="terrain" class="map">
      <gmap-custom-marker :offsetY="-10" :key="index" v-for="(m, index) in markers" :z-index="1" :marker="m"
        alignment="top">
        <CustomGenericMarker :value="m.title" />
      </gmap-custom-marker>
    </GmapMap>
  </div>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'

import { LATITUDE, LONGITUDE } from '../../../utils/config'
import CustomGenericMarker from './google-map/CustomGenericMarker'
const DEFAULT_ZOOM = 14

export default {
  name: 'CustomGoogleMap',
  components: { CustomGenericMarker, 'gmap-custom-marker': GmapCustomMarker },
  props: {
    markers: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '600px'
    }
  },
  watch: {
    markers() {
      this.fitBounds()
    }
  },
  data: function () {
    return {
      center: this.markers.length > 0 ? this.markers[0] : { lat: LATITUDE, lng: LONGITUDE },
      zoom: DEFAULT_ZOOM
    }
  },
  methods: {
    fitBounds() {
      const coords = this.markers.map(item => {
        return { lat: item.lat, lng: item.lng }
      })
      this.$refs.mapRef.$mapPromise.then((map) => {
        const bounds = new window.google.maps.LatLngBounds()
        coords.forEach(c => {
          bounds.extend(c)
        })
        setTimeout(() => bounds.length > 1 ? map.fitBounds(bounds) : map.panToBounds(bounds), 500)
      })
    }
  },
  created() {
    this.$nextTick(() => {
      this.fitBounds()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/CustomGoogleMap.vue